export const yandexRichGoals = () => {
  const goalsFormSuccess = () => {
    if (window && window.ym) {
      window.ym(42281864, 'reachGoal', 'form_success');
    }
  };

  const goalsClickPhone = () => {
    if (window && window.ym) {
      window.ym(42281864, 'reachGoal', 'click_phone');
    }
  };

  const goalsClickHeaderPhone = () => {
    if (window && window.ym) {
      window.ym(42281864, 'reachGoal', 'phoneheader-click');
    }
  };

  const goalsCalltouchSentForm = () => {
    if (window && window.ym) {
      window.ym(42281864, 'reachGoal', 'callbackCalltouch-sentForm');
    }
  };

  const goalsClickTg = () => {
    if (window && window.ym) {
      window.ym(42281864,'reachGoal','telegram-click');
    }
  };

  const goalsClickVk = () => {
    if (window && window.ym) {
      window.ym(42281864,'reachGoal','vk-click');
    }
  };

  return {
    goalsClickPhone,
    goalsFormSuccess,
    goalsCalltouchSentForm,
    goalsClickTg,
    goalsClickVk,
    goalsClickHeaderPhone
  };
};
